export default class Action {
  toTarget(url) {
    window.location.href = url;
  }

  dashboardSidebar() {
    const id = 'anim-dash-1';
    const anim = 'rotate-180';
    let buttonAnimateIcon = document.getElementById(id);
    const idsidebar = "dash-sidebar";
    let sidebarDash = document.getElementById(idsidebar);
    let headDashboard = document.getElementById('header-dashboard');
    let dataContent = document.getElementById('data-content');
    const barAnimateHide = "bardash-anim-hide";
    const barAnimateShow = "bardash-anim-show";
    const barLoginFixpst = "bardash-fix-pst";
    // SE BARRA ESTA OCULTA
    if (buttonAnimateIcon.className === 'rotate-180-fix') {
      sidebarDash.classList.remove(barAnimateHide);
      sidebarDash.classList.add(barAnimateShow);
      buttonAnimateIcon.className = 'rotate-0';
      headDashboard.classList.remove("l-0");
      dataContent.classList.remove("l-0");
      setTimeout(() => {
        sidebarDash.classList.remove(barLoginFixpst);
        sidebarDash.classList.remove(barAnimateShow);

      },480/*ms*/);
    // SE BARRA ESTA VISIVEL
    } else {
      headDashboard.classList.add("l-0");
      dataContent.classList.add("l-0");
      sidebarDash.classList.add(barAnimateHide);
      buttonAnimateIcon.className = anim;
      setTimeout(() => {
        sidebarDash.classList.add(barLoginFixpst);
        sidebarDash.classList.remove(barAnimateHide);
        buttonAnimateIcon.className = 'rotate-180-fix';
      },480);
    }
  }

  hideBar(){
    const id = 'anim-login-1';
    const anim = 'rotate-180';
    let tag = document.getElementById(id);
    const idsidebar = "sidebar-login";
    let sidebarlogin = document.getElementById(idsidebar);
    const barAnimateHide = "barlogin-anim-hide";
    const barAnimateShow = "barlogin-anim-show";
    const barLoginFixpst = "barlogin-fix-pst";
    // SE BARRA ESTA OCULTA
    if (tag.classList.contains('rotate-180-fix')) {
      sidebarlogin.classList.remove(barAnimateHide);
      sidebarlogin.classList.add(barAnimateShow);
      tag.classList.add('rotate-0');
      setTimeout(() => {
        sidebarlogin.classList.remove(barLoginFixpst);
        sidebarlogin.classList.remove(barAnimateShow);
        tag.classList.remove('rotate-180-fix');
        tag.classList.remove('rotate-0');
      },480/*ms*/);
    // SE BARRA ESTA VISIVEL
    } else {
      sidebarlogin.classList.add(barAnimateHide);
      tag.classList.add(anim);
      setTimeout(() => {
        sidebarlogin.classList.add(barLoginFixpst);
        sidebarlogin.classList.remove(barAnimateHide);
        tag.classList.add('rotate-180-fix');
        tag.classList.remove(anim);
      },480);
    }
  }
}
